<template>
    <el-tooltip v-if="platform" :content="platform.name" placement="top-start">
        <span class="badge-platform" :class="{badge: true, [`${custom_class}`]: !!custom_class, [`${calcClass}`]: true}" :style="{'background-color': color}"><span>{{ text }}</span></span>
    </el-tooltip>
</template>

<script>
import PlatformHelper from "../../helpers/platform";

export default {
    name: "PlatformIcon",
    props: {
        id: Number,
        custom_class: String,
    },
    data: () => ({
        colors: [
            "#ffa7a7",
            "#ffd4a3",
            "#fffba5",
            "#b9ffa8",
            "#a5ffea",
            "#9de3ff",
            "#9faeff",
            "#d09fff",
            "#ffa1fd",
        ],
    }),
    computed: {
        platform () {
            return PlatformHelper.get(this.id);
        },
        text () {
            return this.platform.name.slice(0,1).toUpperCase();
        },
        color() {
            if (+this.id === 35) return '#9faeff';
            if (+this.id === 211) return '#9de3ff';
            if (+this.id === 243) return '#9de3ff';
            if (+this.id === 263) return '#46c721';
            if (+this.id === 273) return '#f4b400';
            let index = (this.id - 1) % this.colors.length;
            if (this.colors[index] === undefined) return "#eaeaea";
            return this.colors[index];
        },
        calcClass() {
            if (+this.id === 273) return 'pl-octagon';
            let index = this.id - 1;
            if (index >= 0 && index <= 8) {
                return 'pl-circle';
            } else if (index >= 9 && index <= 17) {
                return 'pl-square';
            } else if (index >= 18 && index <= 26) {
                return 'pl-style-1';
            } else if (index >= 27 && index <= 35) {
                return 'pl-style-2';
            } else if (index >= 36 && index <= 44) {
                return 'pl-style-3';
            } else if (index >= 45 && index <= 53) {
                return 'pl-style-4';
            } else if (index >= 54 && index <= 144) {
                return 'pl-style-5';
            } else if (index >= 145 && index <= 236) {
                return 'pl-style-6';
            }
            return 'pl-empty';
        }
    }
}
</script>

<style scoped>
.pl-empty {

}
.pl-circle {
    border-radius: 50%;
}
.pl-square {
    border-radius: 15%;
}
.pl-octagon {
    clip-path: polygon(
        29.29% 0%, 70.71% 0%,
        100% 29.29%, 100% 70.71%,
        70.71% 100%, 29.29% 100%,
        0% 70.71%, 0% 29.29%
    );
    border-radius: 0;
}
.pl-style-1 {
    border-radius: 15% 50% 15% 50%;
}
.pl-style-2 {
    border-radius: 50% 15% 50% 50%;
}
.pl-style-3 {
    border-radius: 15% 15% 50% 50%;
}
.pl-style-4 {
    border-radius: 50% 50% 15% 15%;
}
.pl-style-5 {
    border-radius: 15% 50% 50% 15%;
}
.pl-style-6 {
    border-radius: 50% 15% 15% 50%;
}

</style>
